// import { WalletInfoWithOpenMethod, WalletOpenMethod } from '../models/connected-wallet';
import { tryGetLocalStorage } from '../app/utils/web-api';
import {WalletInfoWithOpenMethod, WalletOpenMethod} from "../models";

export class LastSelectedWalletInfoStorage {
    private readonly localStorage: Storage;

    private readonly storageKey = 'okx_wallet_connect_ui_last-selected-wallet-info';

    constructor() {
        this.localStorage = tryGetLocalStorage();
    }

    public setLastSelectedWalletInfo(
        walletInfo:
            | WalletInfoWithOpenMethod
            | {
                  openMethod: WalletOpenMethod;
              }
    ): void {
        this.localStorage.setItem(this.storageKey, JSON.stringify(walletInfo));
    }

    public getLastSelectedWalletInfo():
        | WalletInfoWithOpenMethod
        | {
              openMethod: WalletOpenMethod;
          }
        | null {
        const walletInfoString = this.localStorage.getItem(this.storageKey);

        if (!walletInfoString) {
            return null;
        }

        return JSON.parse(walletInfoString);
    }

    public removeLastSelectedWalletInfo(): void {
        this.localStorage.removeItem(this.storageKey);
    }
}
